import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "../integration/iframe"

export const PolicyLookup: React.FC<RouteComponentProps> = () => (
  <>
    <DocumentTitleOverride>Flock Motor | Policy Lookup</DocumentTitleOverride>
    <IFrame path="lookup-policy" />
  </>
)
